import { render, staticRenderFns } from "./city-popup.vue?vue&type=template&id=2f478340&scoped=true&"
import script from "./city-popup.vue?vue&type=script&lang=js&"
export * from "./city-popup.vue?vue&type=script&lang=js&"
import style0 from "./city-popup.vue?vue&type=style&index=0&id=2f478340&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f478340",
  null
  
)

export default component.exports